// Values are wire values for the `originGameType` query param of POST /api/v1/user — must match the backend GameType enum.
export enum OriginGameType {
  soloQuiz = 'SOLO_QUIZ',
  predictionGame = 'PREDICTION_GAME',
}
